import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { useTestIdAttribute } from '../../hooks/useTestIdAttribute';
import { useTextStyle } from './useTextStyle';
const StyledText = styled('span', (p) => p.$style);
const elementMap = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    s1: 'p',
    s2: 'p',
    b1: 'p',
    b2: 'p',
    b3: 'p',
    button: 'p',
    caption: 'p',
};
export const Text = ({ children, variant = 'b1', color = 'dark', underline = false, colorOverride, font = 'primary', fontWeightOverride, textTransform, textDecoration, align, as: asPassed, testId, whiteSpace, overflow, textOverflow, display, wordWrap, maxWidth, minWidth, userSelect, }) => {
    const style = useTextStyle({
        font,
        variant,
        color,
        underline,
        colorOverride,
        fontWeightOverride,
        textTransform,
        textDecoration,
        align,
        whiteSpace,
        overflow,
        textOverflow,
        display,
        wordWrap,
        maxWidth,
        minWidth,
        userSelect,
    });
    const testIdAttribute = useTestIdAttribute(testId);
    const as = asPassed ?? elementMap[variant];
    return (_jsx(StyledText, { $as: as, $style: style, ...testIdAttribute, children: children }));
};
